// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v-sG","controls":"styles_controls__32xgr","charLimit":"styles_charLimit__1h9b8","input":"styles_input__1gPJO","send":"styles_send__17bD_"};